import { getRegularCurrencies } from '@okletsplay/core';
import React, { FC } from 'react';
import QRCode from 'react-qr-code';
import { Box, Typography } from '@mui/material';
import { MultiCurrencyConfig } from 'config/multi-currency-config';
import { walletSelector } from 'modules/payments/store/wallet/selectors';
import { userPaymentAccountsSelector } from 'modules/payments/store/user-payment-accounts/selectors';
import { useSelector } from 'react-redux';
import { TextInput } from 'shared/components/Form/TextInput';
import { useStyles } from './CryptoAddress.style';

export const CryptoAddress: FC = () => {
  const { classes } = useStyles();

  const wallerDepositAddress = useSelector(walletSelector.depositAddress);
  const balanceDepositAddress = useSelector(userPaymentAccountsSelector.depositAddress);

  const depositAddress = MultiCurrencyConfig.isReplenishmentEnabled()
    ? balanceDepositAddress
    : wallerDepositAddress;

  const getQrCodeLabel = () => {
    const currencies = getRegularCurrencies(MultiCurrencyConfig.currencyType());
    return `Send only ${currencies.join(', ')} to the deposit address`;
  };

  if (!depositAddress) {
    return <Typography>Oops, cannot show crypto address...</Typography>;
  }

  return (
    <>
      <Box className={classes.root}>
        <Box className={classes.codeContainer}>
          <QRCode value={depositAddress} className={classes.code} />
        </Box>
        <Typography className={classes.codeHint} mb={1}>
          {getQrCodeLabel()}
        </Typography>

        <Box className={classes.inputContainer}>
          <Typography className={classes.inputLabel}>Deposit address:</Typography>
          <TextInput value={depositAddress} withCopy readOnly sx={{ flexGrow: 1 }} />
        </Box>
      </Box>
    </>
  );
};
